import { ReactNode } from 'react'
import cx from 'classnames'

import Styles from './WhiteButton.module.scss'

interface Props {
  children: ReactNode
  className?: string
  disabled?: boolean
  onClick: () => void
}

export const WhiteButton = ({ onClick, className, children, disabled }: Props) => {
  return (
    <button className={cx(Styles.whiteButton, className)} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  )
}
